import { initReactI18next } from 'react-i18next';
import { createInstance } from 'i18next';
import englishTranslations from './lang/en';
import spanishTranslations from './lang/es';
const translations = {
    en: { translation: englishTranslations },
    es: { translation: spanishTranslations }
};
const i18n = createInstance({
    debug: false,
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false
    },
    resources: translations
});
i18n.use(initReactI18next).init();
export const { t } = i18n;
export default i18n;
